import { Pipe, PipeTransform } from '@angular/core';
import { ParametrosService } from 'src/app/service/parametros.service';

@Pipe({
  name: 'moneda',
  pure: false
})
export class MonedaPipe implements PipeTransform {

  constructor(private parametros: ParametrosService) { }

  transform(value: any): string {
    if (value === null || value === undefined || value === '') return '';

    const numero = this.parseNumero(value);
    if (numero === null) return '';

    const signo = this.parametros.signoMoneda || '$';
    const decimales = this.parametros.monedaDecimales ?? 2;
    // el backend entrega el monto en la unidad mínima (centavos): 1660 -> 16.60
    const numeroReal = numero / Math.pow(10, decimales);
    const formateado = numeroReal.toLocaleString('en-US', {
      minimumFractionDigits: decimales,
      maximumFractionDigits: decimales
    });

    return `${signo} ${formateado}`;
  }

  private parseNumero(value: any): number | null {
    if (typeof value === 'number') return isNaN(value) ? null : value;

    const limpio = String(value).replace(/[^0-9.-]/g, '');
    if (!limpio) return null;

    const numero = Number(limpio);
    return isNaN(numero) ? null : numero;
  }
}
